var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2.21967 5.22781C2.51256 4.92406 2.98744 4.92406 3.28033 5.22781L8 10.1223L12.7197 5.22781C13.0126 4.92406 13.4874 4.92406 13.7803 5.22781C14.0732 5.53155 14.0732 6.02401 13.7803 6.32775L8.53033 11.7722C8.23744 12.0759 7.76256 12.0759 7.46967 11.7722L2.21967 6.32775C1.92678 6.02401 1.92678 5.53155 2.21967 5.22781Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.cfaf8185dc5560fcd9954b0fe45aebfb.svg";
export { ForwardRef as ReactComponent };